<template>
  <div
    class="mt-16 sm:mt-24"
    @mouseover="stopTimer()"
    @mouseleave="resetTimer()"
  >
    <header class="flex justify-center flex-col sm:flex-row">
      <SlideTab
        v-for="slide in slides"
        :key="slide.id"
        :slide="slide"
        :isPaused="isPaused"
        @tabChanged="setTab"
      ></SlideTab>
    </header>

    <main class="px-1 mt-8">
      <transition name="fade" mode="out-in">
        <img
          :src="slides[activeTab].image"
          :alt="slides[activeTab].title"
          :key="slides[activeTab].id"
          width="1138px"
          height="569px"
          class="rounded-xl shadow-md border border-gray-300"
          ref="slideimg"
        />
      </transition>
    </main>
  </div>
</template>

<script>
import BoardIcon from "../images/icons/board.svg";
import RoadmapIcon from "../images/icons/roadmap.svg";
import ChangelogIcon from "../images/icons/changelog.svg";

import BoardScreenshot from "../images/screenshots/board.png";
import RoadmapScreenshot from "../images/screenshots/roadmap.png";
import ChangelogScreenshot from "../images/screenshots/changelog.png";

import SlideTab from "./tab";

export default {
  data: function() {
    return {
      activeTab: 0,
      slides: [
        {
          id: 0,
          title: "Collect feedback",
          icon: BoardIcon,
          image: BoardScreenshot,
          isActive: true
        },
        {
          id: 1,
          title: "Show progress",
          icon: RoadmapIcon,
          image: RoadmapScreenshot,
          isActive: false
        },
        {
          id: 2,
          title: "Announce updates",
          icon: ChangelogIcon,
          image: ChangelogScreenshot,
          isActive: false
        }
      ],
      slideDuration: 5, // seconds
      startedAt: 0,
      isPaused: false,
      slideInterval: null,
      BoardIcon,
      RoadmapIcon,
      ChangelogIcon,
      BoardScreenshot,
      RoadmapScreenshot,
      ChangelogScreenshot
    };
  },

  mounted: function() {
    this.resetTimer();
  },

  components: {
    SlideTab
  },

  methods: {
    setTab: function(tab_id) {
      this.slides.forEach(t => (t.isActive = false));
      this.slides.find(t => t.id === tab_id).isActive = true;
      this.activeTab = tab_id;
    },

    resetTimer: function() {
      this.isPaused = false;

      this.slideInterval = window.setInterval(() => {
        if (!this.isPaused) {
          if (this.activeTab + 1 === this.slides.length) {
            this.setTab(0);
          } else {
            this.setTab(this.activeTab + 1);
          }
        }
      }, this.slideDuration * 1000);
    },

    stopTimer: function() {
      this.isPaused = true;
      window.clearInterval(this.slideInterval);
    }
  }
};
</script>

<style>
.fade-enter,
.fade-leave-to {
  opacity: 0.1;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease;
}
</style>
